export enum HEXFormat
{
    RGBA = 'RGBA',
    ARGB = 'ARGB'
}

export abstract class ColorUtil
{
    // todo: convert alpha to number
    public static splitHEXWithAlpha(hex:string, format:HEXFormat = HEXFormat.RGBA):{hex:string, alpha:string}
    {
        if( hex.length === 4 || hex.length === 7 )
            return {hex, alpha: '00'};

        if( hex.length === 9 )
        {
            const rgba:boolean = format === HEXFormat.RGBA;

            return {
                hex: `#${hex.substring(rgba ? 1 : 3, rgba ? 7 : 9)}`,
                alpha: hex.substring(rgba ? 7 : 1, rgba ? 9 : 3)
            };
        }

        if( hex.length === 5 )
        {
            const rgba:boolean = format === HEXFormat.RGBA;

            return {
                hex: `#${hex.substring(rgba ? 1 : 2, rgba ? 4 : 5).split('').map(c => `${c}${c}`).join('')}`,
                alpha: hex.substring(rgba ? 4 : 1, rgba ? 5 : 2).split('').map(c => `${c}${c}`).join('')
            };
        }
    }

    public static RGBToRGBA(rgbString:string, alpha:number):string
    {
        const rgbRegex = /rgb\(\s*(?<red>\d{1,3})\s*,\s*(?<green>\d{1,3})\s*,\s*(?<blue>\d{1,3})\s*\)/;
        const {red, green, blue} = rgbString.match(rgbRegex)['groups'];
        return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
    }
}
